import { MaterialIcons } from "@expo/vector-icons";
import { Button, HStack, Icon, Text } from "native-base";
import React from "react";

import { useAppNavigation } from "@/hooks/application/navigation";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";

type BreadcrumbProps = {
  routes: {
    title: string;
    routeName: string;
    params?: any;
  }[];
};

const Breadcrumb = ({ routes }: BreadcrumbProps) => {
  const { navigate } = useAppNavigation<HomeNavigation>();

  const onNavigate = (routeName: string, params: any) => {
    navigate(routeName as never, params as never);
  };

  return (
    <HStack alignItems="center">
      {routes.map((route, index) => {
        const isActive = index < routes.length - 1;
        return (
          <HStack key={index} justifyContent="center" alignItems="center">
            <Button
              variant="link"
              disabled={!isActive}
              onPress={() => onNavigate(route.routeName, route.params)}>
              <Text color={isActive ? "primary.600" : "text.600"} bold>
                {route.title}
              </Text>
            </Button>
            {isActive && <Icon as={<MaterialIcons name="arrow-forward-ios" />} color="gray.300" />}
          </HStack>
        );
      })}
    </HStack>
  );
};

export default Breadcrumb;
